import React, { useState, useEffect, useRef } from "react";

import cx from "classnames";
import _ from "lodash";

import { Button, Form } from "react-bootstrap";
import { Property } from "components/Editor/components/properties";
import { IKImage } from "imagekitio-react";
import { VideoView } from "components/Editor/widgets/video";
import { MediaLibraryModal } from "components/MediaLibrary";
import { rgbaToHex } from "components/Editor/helper/color";

import styles from "./varibale.module.scss";


export const TextVariableInput = React.memo(({ value, onChange, onBlur, key }) => {

  const inputRef = useRef();

  const handleChangeValue = () => {
    if (inputRef.current) {
      inputRef.current.value = value; // Set the new value
    }
  };

  useEffect(()=>{
    handleChangeValue()
  },[value])

  return (
    <Form.Control
      key={key}
      ref={inputRef}
      type="text"
      className={styles.textVariable}
      placeholder=""
      onChange={onChange}
      onBlur={onBlur}
      value={value}
    />
  );
});

export const ColorPickerVariable = React.memo(({ value, onChange, key }) => {
  return (
    <div key={key} className={styles.colorPickerWrapper}>
      <Property.Color title={""} value={value} onChange={onChange} showBrandkit={false}/>
      <span className={styles.colorTag}>{rgbaToHex(value)}</span>
    </div>
  );
});

export const ImageVaribale = ({ value, storyboard, onChange, key }) => {
  const imageRef = React.useRef(null);
  const [showMedia, setShowMedia] = useState(false);

  const toggleUploadMedia = (e) => {
    setShowMedia(!showMedia);
  };

  const handleChangeImage = (media) => {
    setShowMedia(false);
    onChange(media[0]);
  };
  
  const handleDeleteImage = () => {
    onChange(null);
  }

  return (
    <div key={key} className={styles.imageConatiner}>
        <div
            className={cx(styles.overlayButtonContainer, {
            [styles.showAlways]: !value,
          })}
        >
          <div className={styles.overlayBg}></div>
          {value &&
            <div className={styles.iconWrapper} onClick={handleDeleteImage}>
              <i className={cx(styles.icon, 'cleverstory-close')} />
            </div>
          }
            <Button
              className={cx(styles.imageUploadButton)}
              variant="primary"
              onClick={toggleUploadMedia}
            >
              <i className={cx("cleverstory-upload", styles.icon)} />
              <span className={styles.lable}>Upload Image</span>
            </Button>
          </div>
      <div className={styles.imageWrapper}>
        {value && (
          <IKImage
            className={styles.imageView}
            key={key}
            ref={imageRef}
            path={value?.url}
            width={"100%"}
            height={"226px"}
            // transformation={transformation}
          />
        )}
      </div>
      <span className={styles.label}>{value?.name}</span>
      <MediaLibraryModal
          show={showMedia}
          mediaTypes = {['image']}
          storyboard={storyboard}
          onSelect={handleChangeImage}
          onClose={toggleUploadMedia}
        />
    </div>
  );
};

export const VideoVaribale = ({storyboard, value, onChange, key }) => {
  const videoRef = React.useRef(null);
  const [showMedia, setShowMedia] = useState(false);

  const toggleUploadMedia = (e) => {
    setShowMedia(!showMedia);
  };

  const handleChangeVideo = (media) => {
    setShowMedia(false);
    onChange(media[0]);
  };

  const handleDeleteVideo = () => {
    onChange(null);
  }
  return (
    <div key={key} className={styles.imageConatiner}>
      <div className={cx(styles.overlayButtonContainer, { 
           [styles.showAlways]: !value,
          })}
      >
        <div className={styles.overlayBg}></div>
        {value &&
          <div className={styles.iconWrapper} onClick={handleDeleteVideo}>
            <i className={cx(styles.icon, 'cleverstory-close')} />
          </div>
        }
        <Button
          className={cx(styles.imageUploadButton)}
          variant="primary"
          onClick={toggleUploadMedia}
        >
          <i className={cx("cleverstory-upload", styles.icon)} />
          <span className={styles.lable}>Upload Video</span>
        </Button>
      </div>
      <div className={styles.imageWrapper}>
        {value && (
          <VideoView
            className={styles.videoView}
            key={key}
            ref={videoRef}
            url={value?.url}
            width={"100%"}
            // transformation={transformation}
          />
        )}
      </div>
      <span className={styles.label}>{value?.name}</span>
      <MediaLibraryModal
          show={showMedia}
          mediaTypes = {['video']}
          storyboard={storyboard}
          onSelect={handleChangeVideo}
          onClose={toggleUploadMedia}
        />
    </div>
  );
};
